var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lingue-flags"},_vm._l((_vm.lingue || []),function(l){return _c('img',{key:l.lang,class:{ 'lingue-flag--off': !l.nome },attrs:{"src":_vm.bandiera(l.lang),"alt":l.lang,"title":_vm.titolo(l)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }